const {
	REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
	REACT_APP_AWS_COGNITO_REGION,
	// REACT_APP_AWS_PROJECT_REGION,
	REACT_APP_AWS_USER_FILES_S3_BUCKET,
	REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
	REACT_APP_AWS_USER_POOLS_ID,
	REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
} = process.env;
const awsConfigurations = {
	Auth: {
		identityPoolId: REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
		region: REACT_APP_AWS_COGNITO_REGION,
		userPoolId: REACT_APP_AWS_USER_POOLS_ID,
		userPoolWebClientId: REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
	},
	Storage: {
		AWSS3: {
			bucket: REACT_APP_AWS_USER_FILES_S3_BUCKET,
			region: REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
		},
	},
};

export default awsConfigurations;
